import { h } from 'preact';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import Main from './views/Main';
import { NODE_ENV } from './constants';

/*
  IMPORTANT: The reason we have only one registered route (which is, by the way, a wildcard)
  pointing to the Main component is that we are leveraging the app-shell design, specifically
  the way it loads micro FE apps.

  The improvements consist of two steps:
   1) Deprecating the old way of doing this loading process, which relies on the browser routing
      that is used to listen to route changes, get the new route path and load a micro app matching that
      routing path name. All this logic is now encapsulated into the Main component, which should
      remain untouched from now on;
   2) Start to define new route paths that are associated to a single page component with a well defined
      context and responsibilities set. These page components will use the MicroApp component to load the
      micro apps, and legacy routes should be refactored - on a iterative manner - to use react-router routes
      and have their own individual page components.

  For more information, refer to the ADR link:
  https://www.notion.so/shorewiki/App-Shell-architecture-redesign-a842d1054de44867a9fa9a1228dab64d

*/

const router = deps => {
  let playgroundRoutes = [];

  if (NODE_ENV === 'development') {
    // eslint-disable-next-line global-require
    const { default: createPlaygroundRoutes } = require('../playground/routes');

    playgroundRoutes = createPlaygroundRoutes(deps);
  }

  return createBrowserRouter([
    ...playgroundRoutes,
    {
      path: '*',
      // This component is DEPRECATED and must remain untouched.
      element: <Main deps={deps} />,
    },
  ]);
};

const Router = ({ deps }) => <RouterProvider router={router(deps)} />;

export default Router;
